import {Pipe, PipeTransform} from "@angular/core";
import {FordocUserService} from "@app/services/fordoc-user.service";

@Pipe({
  name: 'fordocUserPipe'
})
export class FordocUserPipe implements PipeTransform{

  fordocUser: string;

  constructor(private fordocService:FordocUserService){

  }

  transform(value: any, ...args: any[]): string | Promise<string> {
    if(this.fordocUser){
      return this.fordocUser;
    }
    if(value){
      return this.fordocService.get(value)
        .toPromise()
        .then(res => {
          this.fordocUser = res.lastName.toUpperCase() + ' ' + res.firstName;
          return this.fordocUser;
      });
    }
  }

}
